module.exports = __webpack_public_path__ + "img/grid.2af72d41.svg";